// extracted by mini-css-extract-plugin
module.exports = {"label":"remarks_label__1X1oy"};